

import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Card, Badge, ProgressBar, Button } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { toast } from 'react-toastify';
import { getAuthToken } from "../../utils/token";
import TrainingSchedule from "./TrainingSchedule";
import { formatDate } from '../../utils/formatDate';
import Loader from '../loader/Loader';

const OperatorPerformamceModal = ({ show, handleClose, operatorId, operatorIds }) => {
  const [operatorList, setOperatorList] = useState([])
  const [loading, setLoading] = useState(false);
  const [trainingSchedule, setTrainingSchedule] = useState(false)
  const [target, setTarget] = useState(0);
  const [productName, setProductName] = useState("")
  const fetchOperatorPerList = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      let response;
      if (operatorId) {
        response = await axios.get(
          `${config.API}/supervisor/operatorperformance/${operatorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else if (operatorIds) {
        response = await axios.get(
          `${config.API}/manager/operatorperformamce/${operatorIds}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        return;
      }
      const operatorData =
        response?.data?.operator_performance ??
        response?.data?.operator ??
        [];
      setOperatorList(Array.isArray(operatorData) ? operatorData : []);
      const apiTarget =
        response?.data?.target ??
        operatorData?.[0]?.target ??
        0;

      setTarget(Number(apiTarget) || 0);
      const productName =
        operatorData?.[0]?.product?.name ??  response?.data?.product ?? 0;
      setProductName(productName);

    } catch (err) {
      console.error("Error fetching operator performance:", err);
      toast.error("Failed to load operator performance data.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (operatorId || operatorIds) {
      fetchOperatorPerList();
    }
  }, [operatorId, operatorIds]);


  return (
    <Modal show={show} onHide={handleClose} size="lg" centered className='font_family'>
      {
        loading ? (
          <Loader />
        ) : (
          <Modal.Body className='p-5'>
            <strong className='fs-4'>Operator Performamce</strong>
            {/* Machine Info */}
            <Card className="mb-3 p-3 bg-light border-0 mt-3">
              <div><strong>Operator Performamce</strong></div>
              <Row className='mt-2'>
                <Col md={6}>
                  <div>Name: <span className="fw-semibold">{operatorList[0]?.user?.name}</span></div>
                  <div>Section: <span className="fw-semibold">{operatorList[0]?.machine?.name}</span></div>
                  <div>Skillset: <span className="fw-semibold">{operatorList[0]?.machine?.name}</span></div>
                </Col>
                <Col md={6}>
                  <div>Emp ID: <span className="fw-semibold">{operatorList[0]?.user?.email}</span></div>
                  <div>Performamce: <span className="fw-semibold">
                    <Badge
                      bg="success-subtle"
                      className="p-2 px-2 rounded-pill text-dark"
                    >
                      {operatorList[0]?.machine?.type}
                    </Badge>
                  </span>

                  </div>
                  <div>Attendance: <span className="fw-semibold">100%</span></div>
                </Col>
              </Row>
            </Card>

            {/* Operator Info */}
            <Card className="mb-3 p-3 bg-light border-0">
              <div><strong>Currect Allocation</strong></div>
              <Row className='mt-2'>
                <Col md={6}>
                  <div>Machine: <span className="fw-semibold">{operatorList[0]?.machine?.machine_code}</span></div>
                  <div>Product: <span className="fw-semibold">{operatorList[0]?.product?.name ?? "Rubber Injection "}</span></div>
                </Col>
                <Col md={6}>
                  <div>Process: <span className="fw-semibold">{operatorList[0]?.machine?.type}</span></div>
                  <div>Production Status: <span className="fw-semibold">
                    <Badge
                      bg="success-subtle"
                      className="p-2 px-2 rounded-pill text-dark"
                    >
                      {operatorList[0]?.machine?.status}
                    </Badge>
                  </span>
                  </div>
                </Col>
              </Row>
            </Card>

            <Row className="mb-2 align-items-center">
              <Col xs={12} className="mb-1">
                <span className="fw-semibold">Production Information</span>
              </Col>
              <Col xs={6} md={4}>
                <div>
                  <strong>Shift:</strong>{" "}
                  <span className="text-muted">{operatorList[0]?.shift}</span>
                </div>
                <div className="mt-1">
                  <strong>Date:</strong>{" "}
                  <span className="text-muted">
                    {formatDate(operatorList[0]?.user?.updated_at)}
                  </span>
                </div>
              </Col>
              <Col xs={6} md={4} className="text-md-end ms-auto">
                {((operatorList[0]?.total_units_produced / target) * 100).toFixed(2)}%
                <br />
                <small className="text-muted">Efficiency</small>
              </Col>
            </Row>

            {/* MEP Progress */}
            <div className="fw-bold mb-1 d-flex justify-content-between">
              <span>{productName}</span>
              <span>
                {`${operatorList[0]?.total_units_produced ?? 0} / ${target ?? 0}`}
              </span>
            </div>

            <ProgressBar
              now={(operatorList[0]?.total_units_produced / target) * 100}
              className="mb-3"
              style={{ height: '10px' }}
              variant="primary"
            />

            {/* Stats */}
            <Row className="text-center mb-4 p-2">
              <Col className="bg-light py-3 rounded">
                <div className="fs-4 fw-bold">{Number(operatorList[0]?.total_units_produced) || 0}</div>
                <div className="text-muted small">Units Produced</div>
              </Col>
              <Col className="bg-light py-3 rounded mx-2">
                <div className="fs-4 fw-bold">{Number(target) || 0}</div>
                <div className="text-muted small">Target Units</div>
              </Col>
              <Col className="bg-light py-3 rounded">
                <div className="fs-4 fw-bold">{Number(operatorList[0]?.total_units_rejected) || 0}</div>
                <div className="text-muted small">Non-Conformities</div>
              </Col>
            </Row>
          </Modal.Body>
        )
      }

      <Modal.Footer className='border-0'>
        <div className="ms-auto">
          <Button variant="outline-secondary" className="me-2" onClick={handleClose}>
            Close
          </Button>
          <Button variant="dark" onClick={() => setTrainingSchedule(true)}>
            Schedule Training
          </Button>
        </div>
      </Modal.Footer>

      {/* TrainingScheduleModal */}
      <TrainingSchedule
        show={trainingSchedule}
        handleClose={() => setTrainingSchedule(false)}
      />
    </Modal>
  );
};

export default OperatorPerformamceModal;
